module.exports = "//static.hsappstatic.net/LoginUI/static-1.14179/img/donut_desktop.svg"